import { TColorVariant, Typography } from 'shared/ui/typography';
import { FC } from 'react';
import { OrderDetailHeaderTitleProps } from '../types';
import { useOrderDetailHeaderTitle } from 'widgets/orderDetail/lib/hooks/useOrderDetailHeaderTitle';

export const OrderDetailHeaderTitle: FC<OrderDetailHeaderTitleProps> = ({
	order,
	variant,
}) => {
	const { iconSrc, title, color } = useOrderDetailHeaderTitle(order, variant);

	return (
		<Typography
			colorVariant={color as TColorVariant}
			icon={{
				src: iconSrc,
				size: 'medium',
			}}
		>
			{title}
		</Typography>
	);
};
